Greenmile.Survey = Greenmile.Survey || {};
Greenmile.Survey.Templates = Greenmile.Survey.Templates || {};
Greenmile.Survey.Templates.SurveyAnswerTemplateAfterReleased = function () {
  return new Monet.UI.LayoutGenerator({
    'items': [
      {
        'attributes': {
          'id': 'SurveyAnswerTemplateAfterReleased',
        },
        'items': [
          {
            'items': [
              {
                'items': [
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'button',
                      'class': 'btn i18nResource btn-secondary',
                      'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.cancelButton'),
                      'id': 'LinkFormCancelButton',
                    },
                  },
                  {
                    'tag': 'input',
                    'attributes': {
                      'type': 'button',
                      'class': 'btn i18nResource',
                      'value': Monet.I18n.getResourcesByKey('Survey.filter.btn.saveButton'),
                      'id': 'LinkFormSaveButton',
                    },
                  },
                ],
                'attributes': {
                  'class': 'buttonGroup',
                },
              },
              {
                'html': Monet.I18n.getResourcesByKey('Survey.add.header'),
                'attributes': {
                  'class': 'addHeader',
                },
              },
              {
                'attributes': {
                  'class': 'monetInlineAlerContainer',
                },
              },
              {
                'attributes': {
                  'class': 'questionContent',
                },
              },
            ],
            'attributes': {
              'class': 'formContent',
            },
          },
        ],
      },
    ]
  }).render();
};
